import { render } from "./contact_us.vue?vue&type=template&id=1999da88"
import script from "./contact_us.vue?vue&type=script&lang=js"
export * from "./contact_us.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__